<template>
  <div class="quick-contacts">
    <p>
      <font-awesome-icon icon="phone-alt" title="Telefon" />
      <span>Prodej vozů: +420 602 971 548</span>
    </p>
    <p>
      <font-awesome-icon icon="phone-alt" title="Telefon" />
      <span>Autoservis: +420 774 560 510</span>
    </p>
    <p>
      <font-awesome-icon icon="envelope" title="Email" />
      <span>
        <EmailAddress address="info@autokolarovic.cz" />
      </span>
    </p>
  </div>
</template>
<script>
import EmailAddress from "../../UI/EmailAddress";

export default {
  components: {
    EmailAddress
  }
};
</script>
<style lang="scss" scoped>
@import "../../../scss/global.scss";

.quick-contacts {
  display: none;
  p {
    margin: 0;
    padding: 0;

    span {
      padding-left: 0.2rem;
      text-decoration: none;
    }
  }
}
@media (min-width: $min-width) {
  .quick-contacts {
    background-color: #000;
    margin: 0;
    padding: 0.3rem 3rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
  }
}
</style>
